// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_modal__20ABn","modal__content":"modal_modal__content__WAp6q","modal__content__video":"modal_modal__content__video__2AubY","modal__exit":"modal_modal__exit__1JuxO"};